export const requestor = "recommendations-fragment";
